var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AlertDialog'),_c('Drawer'),_c('Navbar'),_c('v-main',[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('div',{staticClass:"main d-flex flex-column"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }